import React from 'react';
import SideMenuItem from './sideMenuItem';
import menuConfig from '../../configurations/menuConfig';




class SideMenu extends React.Component {

    render() {
        //TODO move menu rebuild to componentWillReceiveProps
        this.rebuildMenuItems(this.props);
        return (
            <ul className="nav nav-pills nav-stacked nav-blue">
                {this.menus.length > 0 && this.menus}
            </ul>
        );
    }

    rebuildMenuItems(props)
    {
        this.menus = [];
        if (menuConfig.menus) {

            this.menus = menuConfig.menus.map((menu) => {
                return (
                    <SideMenuItem location={props.location} menuItem={menu} allowedPermissions={menu.permissions} key={menu.key} />
                );
            });
        }
    }


}


export default SideMenu;


// WEBPACK FOOTER //
// ./src/components/side-menu/sideMenu.js